export const NAME = 'credential-integrations';

export const SENSITIVE_FIELDS = {
    api_key: true,
    api_secret: true,
    client_secret: true,
    password: true,
};
